var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCklLogoWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.0362212 1.9762L25.1074 9.65698L20.7236 10.9975L0.0362212 4.65722V7.33824L16.3398 12.338L11.9559 13.6785L0 10.0193V12.7003L7.57207 15.019L0 17.3378V20.0188L29.455 10.9975V9.76567C29.455 8.89614 28.8754 8.13531 28.0421 7.8817L2.53611 0.0922267C1.30428 -0.306304 0.0362212 0.635682 0.0362212 1.9762Z",
    fill: "#ffffff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.0283203 25.3449L29.4834 16.3236V13.6426L0.0283203 22.6639V25.3449Z",
    fill: "#ffffff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5781 29.91L28.0841 22.1206C28.9174 21.867 29.497 21.1061 29.497 20.2366V19.041L0.0419922 28.0623C0.0419922 29.3304 1.31004 30.3086 2.5781 29.91Z",
    fill: "#ffffff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCklLogoWhite);
export default __webpack_public_path__ + "static/media/ckl-logo-white.32e72ceaea545ca1d0ccb3087a8cc649.svg";
export { ForwardRef as ReactComponent };